import { api } from "../../lib/api";

export const STATUS_TONE = {
  draft:           "bg-amber-50 text-amber-800 border-amber-200",
  applied:         "bg-emerald-50 text-emerald-800 border-emerald-200",
  discarded:       "bg-surface-2 text-ink-3 border-line",
  failed:          "bg-red-50 text-red-800 border-red-200",
  rolled_back:     "bg-sky-50 text-sky-800 border-sky-200",
  rollback_failed: "bg-red-50 text-red-800 border-red-200",
};

export const STATUS_LABEL = { rolled_back: "rolled back", rollback_failed: "undo failed" };

export const ACTION_TONE = {
  create:    "bg-emerald-50 text-emerald-800 border-emerald-200",
  update:    "bg-sky-50 text-sky-800 border-sky-200",
  unchanged: "bg-surface-2 text-ink-3 border-line",
  reject:    "bg-red-50 text-red-800 border-red-200",
};

export const COUNT_ORDER = ["create", "update", "unchanged", "reject"];

/* Authenticated download: the endpoints need the bearer token, so fetch as a
 * blob through the api client and hand the browser an object URL. */
export async function downloadThroughApi(path, filename) {
  const r = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 2000);
  return r.headers?.["x-import-note"] || null;
}

export function todayIso() {
  const d = new Date();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${d.getFullYear()}-${mm}-${dd}`;
}
